import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./main.css";
import{ Link} from 'react-router-dom'
import { useLocation } from "react-router-dom";
import {useNavigate} from 'react-router-dom';
function Nav() {
	const navRef = useRef();
	const navigate = useNavigate();
	const location = useLocation();
	const path = location.pathname;
   
	const handleLogout = () =>{
	  localStorage.removeItem('at');
	  navigate('/');
	}
	const token  = localStorage.getItem('at')																																			 
	const showNavbar = () => {
		navRef.current.classList.toggle("responsive_nav");
	};

	return (
		<header>
			<h3> <Link className=" no-underline text-2xl md:text-3xl font-bold italic bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-violet-500 mt-1 " to="/">
           
            Dr. Hira Mujahid
		   </Link></h3>
			<nav ref={navRef}>
			
				
				<Link to="/g/googleScholar"  onClick={showNavbar}   className={` ${
                      path === "/g/googleScholar" ? "active  text-yellow-600" : " text-black"
                    } no-underline    px-2`} > Google Scholar</Link>
				<Link to="/gt/researchGate"  onClick={showNavbar}   className={` ${
                      path === "/gt/researchGate" ? "active  text-yellow-600" : " text-black"
                    } no-underline   px-2 `} > Research Gate </Link>
                    <Link to="/n/newsPaper"  onClick={showNavbar}   className={` ${
                      path === "/n/newsPaper" ? "active  text-yellow-600" : " text-black"
                    } no-underline   px-2 `} > News Paper</Link>
				<Link to="/about" onClick={showNavbar}  className= {` ${
                      path === "/about" ? "active  text-yellow-600" : "text-black"
                    }  px-5 no-underline  hover:text-blue-500 px-2`}> About</Link>
					  
					  <Link to="/contact" onClick={showNavbar}  className= {` ${
                      path === "/contact" ? "active  text-yellow-600" : "text-black"
                    }  px-2 no-underline  hover:text-blue-500`}> Contact</Link>
						
					{token && <>
 
   <button onClick={handleLogout}> Logout</button>
 
  
 </>}
			 

				<button
					className="nav-btn nav-close-btn"
					onClick={showNavbar}>
					<FaTimes />
				</button>
			</nav>
			<button className="nav-btn" onClick={showNavbar}>
				<FaBars />
			</button>
		</header>
	);
}

export default Nav;